import React from 'react';
import { useConfig } from './default-config';

const Advisor = ({ description }: { description: string }) => {
    const { advisorText } = useConfig().texts;
    return (
        <div className="advisor">
            <div className="advice theme-colors-lighter">
                <span className="advice-text">
                    <span className="ikon" role="img" aria-hidden>
                        👋 &nbsp;
                    </span>
                    {description}
                </span>
            </div>
            <div className="consultant">
                <span className="advisor-text">{advisorText}</span>
                <span className="ikon ikon-radgiver-36" aria-hidden />
            </div>
        </div>
    );
};

export default Advisor;
